export default __webpack_public_path__ + "static/media/hayden.bd583f55.jpg";